import { requst } from '../config'

// HSE 日报 - 日历上日数据
export const getHseDiaryCalendarApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/hse/diary/listByCalendar?
            startDay=${params.startDay}
            &endDay=${params.endDay}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            url = `/monitor/hse/diary/listByCalendar?
            startWeek=${params.startWeek}
            &endWeek=${params.endWeek}
            &startDay=${params.startDay}
            &endDay=${params.endDay}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &year=${params.year}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'month':
            url = `/monitor/hse/diary/listByCalendar?
            dateType=${params.dateType}
            &locationId=${params.locationId}
            &projectId=${params.projectId} 
            &endDay=${params.endMonth}
            &year=${params.year}
            &startDay=${params.startMonth}`.replace(/\s*/g, '')
            break
        default:
            break
    }
    return requst.get(url)
}

// 字典数据树
export const getDiaryDictTreeApi = dictType => {
    const url = `/system/dict/data/tree?dictType=${dictType}&status=Y`
    return requst.get(url)
}

// 查询日期
export const getDiaryByDateApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/hse/diary/date?
            produceDate=${params.produceDate}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            url = `/monitor/hse/diary/date?
            week=${params.week}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &year=${params.year}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'month':
            url = `/monitor/hse/diary/date?
            month=${params.month}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &year=${params.year}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        default:
            break
    }
    return requst.get(url)
}

// 查询 id
export const getDiaryByIdApi = id => {
    const url = `/monitor/hse/diary/${id}`
    return requst.get(url)
}

// 提交 HseDiary 总结
export const postDiaryCommentApi = commentData => {
    const url = `/monitor/hse/diary`
    return requst.post(url, { ...commentData })
}

// 修改 HseDiary 总结
export const putDiaryCommentApi = (commentData, id) => {
    const url = `/monitor/hse/diary`
    return requst.put(url, { ...commentData, id })
}

// 获取观察卡数据
export const getCardDataApi = id => {
    const url = `/monitor/hse/diary/observation/list?diaryId=${id}`
    return requst.get(url)
}

// 提交 HseDiary 事件
export const postCardDataApi = (cardData, id) => {
    const url = `/monitor/hse/diary/observation/addOrUpdateBatch/${id}`
    return requst.post(url, cardData)
}

// 获取 HseDiary 事件数据
export const getEventDataApi = id => {
    const url = `/monitor/hse/diary/event/list?diaryId=${id}`
    return requst.get(url)
}

// 获取 HseDiary 暴露数据
export const getExposureDataApi = id => {
    const url = `/monitor/hse/diary/exposure/list?diaryId=${id}`
    return requst.get(url)
}

// 获取事故数据
export const getIncidentDataApi = id => {
    const url = `/monitor/hse/diary/incident/list?diaryId=${id}`
    return requst.get(url)
}

// 提交 HseDiary 事件
export const postEventDataApi = (eventData, id) => {
    const url = `/monitor/hse/diary/event/addOrUpdateBatch/${id}`
    return requst.post(url, eventData) 
}

// 提交 HseDiary 暴露
export const postExposureDataApi = (exposureData, id) => {
    const url = `/monitor/hse/diary/exposure/addOrUpdateBatch/${id}`
    return requst.post(url, exposureData)
}

// 提交 HseDiary 事故
export const postIncidentDataApi = (incidentParams, id) => {
    const url = `/monitor/hse/diary/incident/addOrUpdateBatch/${id}`
    return requst.post(url, incidentParams)
}
